import { useMutation } from "react-query";
import { IMemoModel } from "../../common/models/IMemoModel";
import MemosDataService from "../../services/memos-data-service/MemosDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";

export type UseSaveMemosParameters = {
    customerID: number,
    groupID: number,
    offline: boolean
} & BaseUseMutationParameters<IMemoModel | undefined, IMemoModel>;

export function useSaveMemo({
    customerID,
    groupID,
    offline,
    onError,
    onSuccess
}: UseSaveMemosParameters) {

    return useMutation<IMemoModel | undefined, RestError, IMemoModel>(
        (memo) => {
            return MemosDataService.saveMemo(
                customerID,
                groupID,
                memo,
                offline
            );
        },
        {
            onError: onError,
            onSuccess: onSuccess
        }
    );
}